/**
 * Maps long research category names to shorter display names
 */
export const getShortCategoryName = (fullCategoryName: string): string => {
  const categoryMapping: Record<string, string> = {
    'Technology & Innovation': 'Technology',
    'Business & Professional': 'Business',
    'Content & Creative': 'Creative',
    'Personal Development': 'Growth',
    'Academic & Learning': 'Academic',
    'Current Events & News': 'News',
    'Comprehensive Analysis': 'Analysis'
  };

  return categoryMapping[fullCategoryName] || fullCategoryName;
}; 